<script>
  import { customUserStore } from "./stores/user_store.js";
  import LoginBar from "./LoginBar.svelte";
  import { getData, saveData } from "./helpers/db.js";

const admin=1; 

$: iAmAdmin = $customUserStore && $customUserStore.id==admin;
let lagerliste = [];
  let editing = 0;
  let mouseover = 0;

  let theScroll = 0;
  let scrolly = 0;
  let editRow = null;

  const edit = line => {
    if (iAmAdmin) {
    editRow = line;
    editing = line.id;
    }
  };

  const save = row => {
    saveData({ entity: "lager" }, editRow).then(data => {
      editing = 0;
    });
  };
  const cancel = () => {
    editing = 0;
  };

  const mo = lineid => {
    if (iAmAdmin) {
    mouseover = lineid;
    }
  };

  function doLogout() {
    customUserStore.doLogout();
  }

  const format = val => (val ? val : "");

  const fetchList = userid => {
    getData({ entity: "lagerListe", params: { userid: userid } }).then(data => {
      let typ = "#@#@";
      let grpid = 0;
      data.forEach(element => {
        if (typ != element.typ) {
          grpid++;
          typ = element.typ;
          element.first = true;
        }
        element.grpid = grpid;
        for (var key in element) {
          if (element.hasOwnProperty(key)) {
            var val = element[key];
            if (!val) {
              element[key] = "";
            }
          }
        }
      });
      lagerliste = data;
    });
  };

  const doNew = () => {
    editRow = { typ: "<neues Fahrzeug>", userid: 0 };
    saveData({ entity: "lager" }, editRow).then(data => {
      editing = 0;
        fetchList(0);
    });
//    lagerliste = [editRow, ...lagerliste];
  };

  const copy = line => {
    let res = confirm("das Fahrzeug \n" + line.typ + "\nwird kopiert");
    if (res) {
      editing = 0;
      let copiedObj = {};

      for (let key in line) {
        // This copies each property from the original object to the copy object
        copiedObj[key] = line[key];
      }
      copiedObj.id = null;
      saveData({ entity: "lager" }, copiedObj).then(data => {
        editing = 0;
        fetchList(0);
      });
    }
  };

  const del = line => {
    let res = confirm("das Fahrzeug  \n" + line.typ + "\nwird gelöscht");
    if (res) {
      editing = 0;
      line.userid = 9999;
      saveData({ entity: "lager" }, line).then(data => {
        editing = 0;
        fetchList(0);
      });
    }
  };

  $: if ($customUserStore.id) {
    fetchList(0);
  }

  function handleKeydown(event) {
    let key = event.key;
    let keyCode = event.keyCode;
    if (!$customUserStore.id) {
      // Login
    } else {
      if (editing != 0) {
        if (keyCode == 27) {
          editing = 0;
        }
        if (keyCode == 13) {
          save();
        }
        if (keyCode == 46) {
          del();
        }
      }
    }
  }
</script>

<style>
  table {
    width: 100%;
    table-layout: fixed;
    overflow-wrap: break-word;
    border-collapse: collapse;
  }

  .model {
    width: 50px;
  }
  .bemerkung {
    width: 200px;
  }
  .typ {
    width: 250px;
  }
  .geschnr {
    width: 60px;
  }
  .ausstattung {
    width: 90px;
  }
  .chassis {
    width: 80px;
  }
  .farbe {
    width: 140px;
  }
  .praemie {
    width: 130px;
  }
  .status {
    width: 80px;
  }
  .bestnr {
    width: 50px;
  }
  .bemerkung {
    width: 460px;
  }
  .action {
    width: 70px;
  }
  .hover {
    background-color: #dddddd;
  }

  .titel {
    background-color: #eeeeee;
  }

  .gelb {
    background-color: #ffff88;
  }

  .rot {
    background-color: #ff7d7d;
  }

  .blau {
    background-color: #80c2fd;
  }

  .top {
    border-top: groove rgb(80, 80, 80) 2pt;
  }

  .bottom {
    border-bottom: groove rgb(80, 80, 80) 2pt;
  }

  .first {
    border-top: groove black 1pt;
  }

  .link {
    cursor: pointer;
  }
  .nolink {
    cursor: default;
  }


  @media print {
    .no-print {
      display: none !important;
    }
  }
</style>

<svelte:window on:keydown={handleKeydown} bind:scrollY={scrolly} />

{#if $customUserStore.id || $customUserStore.id == 0}
  <div class="no-print">
    Benutzer: {$customUserStore.username}&#160;&#160;&#160;&#160;<span class="link" on:click={doLogout}>[abmelden]</span>
    {#if $customUserStore.id==admin}
    &#160;&#160;&#160;&#160;
    <span class="link" on:click={doNew}>[neues Fahrzeug]</span>
    {/if}
  </div>
  &#160;
  <table>
    {#if !editing}
      <tr class="titel">
        <td class="model">Modell</td>
        <td class="typ">Typ</td>
        <td class="geschnr">Gesch.Nr.</td>
        <td class="ausstattung">Ausstattung</td>
        <td class="farbe">Farbe</td>
        <td class="chassis">Chassisnr</td>
        <td class="bestnr">Best.Nr</td>
        <td class="status">Status</td>
        <td class="bemerkung">Bemerkungen</td>
        <td class="praemie">Prämien</td>
          {#if iAmAdmin}
        <td class="action no-print">Aktion</td>
          {/if}
      </tr>
    {/if}
    {#each lagerliste as row}
      {#if row.id != editing}
        <tr
          class:link={iAmAdmin}
          class:nolink={!iAmAdmin}
          class:hover={mouseover == row.id}
          class:first={row.first}
          class:gelb={mouseover != row.id && row.spezial == 1}
          class:rot={mouseover != row.id && row.spezial2 == 1}
          class:blau={mouseover != row.id && row.spezial == 1 && row.spezial2 == 1}
          on:mouseover={e => mo(row.id)}>
          <td class="model" on:click={edit(row)}>{format(row.modell)}</td>
          <td class="typ" on:click={edit(row)}>{row.typ}</td>
          <td class="geschnr" on:click={edit(row)}>{format(row.geschnr)}</td>
          <td class="ausstattung" on:click={edit(row)}>
            {format(row.ausstattung)}
          </td>
          <td class="farbe" on:click={edit(row)}>{format(row.farbe)}</td>
          <td class="chassis" on:click={edit(row)}>{format(row.chassisnr)}</td>
          <td class="bestnr" on:click={edit(row)}>{format(row.bestellnr)}</td>
          <td class="status" on:click={edit(row)}>{format(row.status)}</td>
          <td class="bemerkung" on:click={edit(row)}>
            {format(row.bemerkungen)}
          </td>
          <td class="praemie" on:click={edit(row)}>{format(row.praemien)}</td>
          {#if iAmAdmin}
          <td class="action no-print">
            <span
              on:click={() => {
                del(row);
              }}>
              [del]
            </span>
            <span
              on:click={() => {
                copy(row);
              }}>
              [copy]
            </span>
          </td>
          {/if}
        </tr>
      {:else}
        <tr class="titel top">
          <td class="model">Modell</td>
          <td class="typ">Typ</td>
          <td class="geschnr">Gesch.Nr.</td>
          <td class="ausstattung">Ausstattung</td>
          <td class="farbe">Farbe</td>
          <td class="chassis">Chassisnr</td>
          <td class="bestnr">Best.Nr</td>
          <td class="status">Status</td>
          <td class="bemerkung">Bemerkungen</td>
          <td class="praemie">Prämien</td>
          <td class="action">Aktion</td>
        </tr>
        <tr>
          <td class="model">
            <input class="model" bind:value={row.modell} />
          </td>
          <td class="typ">
            <input class="typ" bind:value={row.typ} />
            <input type="checkbox" bind:checked={row.spezial} />
            <input type="checkbox" bind:checked={row.spezial2} />
          </td>
          <td class="geschnr">
            <input class="geschnr" bind:value={row.geschnr} />
          </td>
          <td class="ausstattung">
            <input class="ausstattung" bind:value={row.ausstattung} />
          </td>
          <td class="farbe">
            <input class="farbe" bind:value={row.farbe} />
          </td>
          <td class="chassis">
            <input class="chassis" bind:value={row.chassisnr} />
          </td>
          <td class="bestnr">
            <input class="bestnr" bind:value={row.bestellnr} />
          </td>
          <td class="status">
            <input class="status" bind:value={row.status} />
          </td>
          <td class="bemerkung">
            <input class="bemerkung" bind:value={row.bemerkungen} />
          </td>
          <td class="praemie">
            <input class="praemie" bind:value={row.praemien} />
          </td>
          <td>
            <span class="link" on:click={save}>[ok]</span>
            &#160;
            <span class="link" on:click={cancel}>[abbr]</span>
          </td>
        </tr>
        <tr class="titel bottom">
          <td colspan="11">&#160;</td>
        </tr>
      {/if}
    {/each}
  </table>
{:else}
  <LoginBar />
{/if}
